import { Angle } from "../baseQuantities/angle";
import { Area } from "../baseQuantities/area";
import { Length } from "../baseQuantities/length";
import {
  AppData,
  CalcMode,
  Calculator,
} from "../../interface/functionalityInterface";
import squareAreaFigure from "../../img/calc-figure-area-square.svg";
import rectangleAreaFigure from "../../img/calc-figure-area-rectangle.svg";
import triangleAreaFigure from "../../img/calc-figure-area-triangle.svg";
import circleAreaFigure from "../../img/calc-figure-area-circle.svg";
import triangleSASAreaFigure from "../../img/calc-figure-area-triangleSAS.svg";

const square: CalcMode = {
  id: "001square",
  name: "square",
  baseQuantities: [{ ...Length, name: "side", symbol: "l" }, { ...Area }],
  figure: squareAreaFigure,
  equation: "A=s\u00B2",
};
const rectangle: CalcMode = {
  id: "001rectangle",
  name: "rectangle",
  baseQuantities: [
    { ...Length, name: "length", symbol: "l" },
    { ...Length, name: "width", symbol: "w" },
    { ...Area },
  ],
  figure: rectangleAreaFigure,
  equation: "A=l*w",
};

const triangle: CalcMode = {
  id: "001triangle",
  name: "triangle",
  baseQuantities: [
    { ...Length, name: "base", symbol: "b" },
    { ...Length, name: "height", symbol: "h" },
    { ...Area },
  ],
  figure: triangleAreaFigure,
  equation: "A=b*h/2",
};

const circle: CalcMode = {
  id: "001circle",
  name: "circle",
  baseQuantities: [{ ...Length, name: "radius", symbol: "r" }, { ...Area }],
  figure: circleAreaFigure,
  equation: "A=\u03C0*r\u00B2",
};

const triangle_sas: CalcMode = {
  id: "002triangle",
  name: "triangle(SAS)",
  baseQuantities: [
    { ...Length, name: "side_1", symbol: "x" },
    { ...Length, name: "side_2", symbol: "y" },
    { ...Angle, toolTip: "angle inbetween side 1 and 2", symbol: "xy" },
    { ...Area },
  ],
  figure: triangleSASAreaFigure,
  equation: "0.5*x*y*sin(xy)",
};

export const areCalc: Calculator = {
  type: AppData.CALCULATOR,
  updatedAt: "2022-07-26",
  name: "area",
  branch: "Geometry",
  difficulty: "intermediate",
  inputs: [square, rectangle, triangle, circle, triangle_sas],
  calculate: [
    {
      name: "square",
      equations: [
        {
          target: "area",
          expression: "side^2",
        },
        {
          target: "side",
          expression: "root(area)",
        },
      ],
    },
    {
      name: "rectangle",
      equations: [
        {
          target: "area",
          expression: "(length) * (width)",
        },
        {
          target: "length",
          expression: "(area) / (width)",
        },
        {
          target: "width",
          expression: "(area) / (length)",
        },
      ],
    },
    {
      name: "triangle",
      equations: [
        {
          target: "area",
          expression: "(base) * (height) / 2",
        },
        {
          target: "base",
          expression: "(area) * 2 / (height)",
        },
        {
          target: "height",
          expression: "(area) * 2 / (base)",
        },
      ],
    },
    {
      name: "circle",
      equations: [
        {
          target: "area",
          expression: "pi * (radius) ^ 2",
        },
        {
          target: "radius",
          expression: "root((area) / pi)",
        },
      ],
    },
    {
      name: "triangle(SAS)",
      equations: [
        {
          target: "area",
          expression: "0.5 * (side_1) * (side_2) * sin(angle)",
        },
        {
          target: "side_1",
          expression: "((area) * 2) / ((side_2) * sin(angle))",
        },
        {
          target: "side_2",
          expression: "((area) * 2) / ((side_1) * sin(angle))",
        },
        {
          target: "angle",
          expression: "asin((2 * (area)) / ((side_1) * (side_2)))",
        },
      ],
    },
  ],
};
